import Chat from './Chat';

export default class Group extends Chat {
  description;

  subscriber;

  subs;

  subscriberCount;

  type = 'group';

  constructor(chat) {
    super(chat);
    Object.assign(this, chat);
  }
}
